/**
 * Created For: 地图相关接口
 * Author: chenLiYan.
 * Date: 2018/11/30 0030 15:43.
 */
import request from '@/utils/request'
// 获取子区域信息
export function asyncGetAreaInfo (code, level) {
  return request({
    url: '/v1/lbs_area/get_area',
    params: {
      code, level
    },
    method: 'get'
  })
}
// 获取子区域信息
export function asyncGetChildArea (code = 100000, level = 0) {
  return request({
    url: '/v1/lbs_area/get_child_area',
    params: {
      code, level
    },
    method: 'get'
  })
}
// 按级别查询当前登录用户可用地区
export function asyncGetUserChildArea (area_code = 100000) {
  return request({
    url: '/v1/user/area/me/sub-area',
    params: {
      area_code
    },
    method: 'get'
  })
}
// 查询当前登录用户的可用地区列表
export function asyncGetUserAreaList () {
  return request({
    url: '/v1/user/area/me/list',
    method: 'get'
  })
}

export function getProvinceInfo () {
  return request({
    url: '/v1/jointown/report/permission/province',
    method: 'get'
  })
}

export function getGeography (areaCode, version, type) {
  return request({
    url: '/v1/lbs_area/geography',
    method: 'get',
    params: {
      areaCode,
      version,
      type
    }
  })
}
